import * as yup from 'yup';

export const invoiceGroupSchema = yup.object({
  name: yup.string().required('Invoice group name is required'),
  poNumber: yup.string(),
});
